import { useState } from "react";
import styles from "src/components/layout/BottomNavigationBar/bottomNavigationBar.module.css";
import homeIcon from "src/assets/icon/navigation_home.svg";
import mapIcon from "src/assets/icon/navigation_map.svg";
import profilerIcon from "src/assets/icon/navigation_profile.svg";
import { IoChatbubbles } from "react-icons/io5";
import calenderIcon from "src/assets/icon/navigation_calender.svg";
import BottomNavigationBarItem from "src/components/elements/BottomNavigationBarItem/BottomNavigationBarItem";
import { useLocation } from "react-router";
import { useAtomValue } from "jotai";
import { isLogin_atom } from "src/features/Auth/auth.atom";

const BottomNavigationBar = () => {
    const location = useLocation();
    const [currentPage, setCurrentPage] = useState(location.pathname);

    const isLogin = useAtomValue(isLogin_atom);

    return (
        <div className={styles.navigation_bar_container}>
            <ul>
                <div className={styles.item}>
                    <BottomNavigationBarItem
                        currentPage={currentPage}
                        pagePath="/"
                        setCurrentPage={setCurrentPage}
                        iconPath={homeIcon}
                        label="Home"
                    />
                </div>

                {isLogin && (
                    <div className={styles.item}>
                        <BottomNavigationBarItem
                            currentPage={currentPage}
                            pagePath="/calendar"
                            setCurrentPage={setCurrentPage}
                            iconPath={calenderIcon}
                            label="Calender"
                        />
                    </div>
                )}

                {/* {isLogin && (
                    <div className={styles.item}>
                        <BottomNavigationBarItem
                            currentPage={currentPage}
                            pagePath="/chat-list"
                            setCurrentPage={setCurrentPage}
                            iconPath={IoChatbubbles}
                            label="chat"
                        />
                    </div>
                )} */}

                <div className={styles.item}>
                    <BottomNavigationBarItem
                        currentPage={currentPage}
                        pagePath="/map"
                        setCurrentPage={setCurrentPage}
                        iconPath={mapIcon}
                        label="map"
                    />
                </div>

                <div className={styles.item}>
                    <BottomNavigationBarItem
                        currentPage={currentPage}
                        pagePath="/profile"
                        setCurrentPage={setCurrentPage}
                        iconPath={profilerIcon}
                        label="User"
                    />
                </div>
            </ul>
        </div>
    );
};

export default BottomNavigationBar;
